module.exports = __webpack_public_path__ + "static/media/pixabay3.214697d6.png";